<template>
  <div class="task-detail">
    <div class="task-detail__header">
      <p class="task-name">{{taskInfo.taskName}}</p>
      <div class="task-plan__desc" v-if="taskInfo.taskInform.length > 0">
        <i class="el-icon-warning-outline note"></i>
        <span>任务通知：</span>
        <el-carousel
          height="40px"
          direction="vertical"
          arrow="nerver"
          indicator-position="none"
          class="notice-item__wrap"
        >
          <el-carousel-item v-for="(notic, index) in taskInfo.taskInform" :key="index">
            <p :title="notic">{{ notic }}</p>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="theme-affix" v-if="taskInfo.affix"><a :href="'https://' + taskInfo.affix" target="_blank">查看附件</a></div>
    </div>
    <div class="task-detail__tab">
      <el-menu
          :default-active="activeIndex"
          class="el-menu-demo task-menu"
          mode="horizontal"
          background-color="#F0F2FA"
          @select="handleTabSelect">
        <el-menu-item v-for="(item,index) in activeData"
                      :key="index" class="task-menu__item"
                      :index="item.activeIndex">{{item.title}}
        </el-menu-item>
      </el-menu>
    </div>
    <div class="task-detail__tab-content">
      <task-data :active-index="activeIndex" :btnText="btnText" :themeId="themeId"/>
    </div>
  </div>
</template>

<script>
import  { TaskData } from '@/components/plantFormDialogs'
import { $Cookies } from '@/utils'
import { geTaskDetailApi } from '@/api/plantform/task'
export default {
  name: '',
  data () {
    return {
      activeIndex: '0',
      btnText: '发起直播',
      activeData: [
        {
          activeIndex: '0',
          title: '直播',
          btnText: '发起直播'
        },
        {
          activeIndex: '1',
          title: '资料',
          btnText: '上传资料'
        },
        {
          activeIndex: '2',
          title: '课堂实录',
          btnText: '上传视频'
        }
      ],
      taskInfo: {
        taskName: '',
        taskInform: '',
        isHavingPlan: false,
        affix: ''
      },
      themeId: 0,
    }
  },
  components: { TaskData },
  mounted() {
    this.uid = $Cookies.get('uid')
    this.geTaskDetail()
  },
  methods: {
    // 任务详情
    geTaskDetail () {
      const params = {
        uid: this.uid,
        taskId: this.$route.params.id
      }
      geTaskDetailApi(params).then(data => {
        if (data.success) {
          this.taskInfo = data.result.aloneTask
          this.themeId = data.result.themeId
          // this.taskInfo.affix = '1241243'
        } else {
          this.$message.error(data.errorMsg);
        }
      })
    },

    handleTabSelect(key) {
      this.activeIndex = key;
      this.btnText = this.activeData[key].btnText;
    }
  }
}
</script>
